import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddStaffFromProviderDialog from "./AddStaffFromProviderDialog";
import GoogleIcon from "../../../../../../Assets/Images/google.png";
import adpIcon from "../../../../../../Assets/Images/adv.png";
import alexisIcon from "../../../../../../Assets/Images/Alexis.png";
import BambooHRIcon from "../../../../../../Assets/Images/bambooHr.png";
import bretheIcon from "../../../../../../Assets/Images/breathe.png";
import ceridianIcon from "../../../../../../Assets/Images/ceridian.png";
import charlieIcon from "../../../../../../Assets/Images/charlie.png";
import CsvBulkUploadDialog from "./CsvBulkUploadDialog";
import AddIndividualStaffDialog from "./AddIndividualStaffDialog";
import ArrowIconBtn from "../../../../../../components/RightArrowIconButton/ArrowIconBtn";
import authenticate from "@truto/truto-link-sdk";
import { useMutation, useQuery } from "@apollo/client";
import {
  GENERATE_TRUTO_LINK_TOKEN,
  GET_AVAILABLE_INTEGRATIONS,
} from "../../../../../../apis/organization-apis/people-apis/peopleApis";
import BootstrapTooltip from "../../../../../../components/BootstrapToolTip/BootstrapTooltip";

// Sample icons (replace with actual icons for each provider)
const providerIcons = [
  GoogleIcon,
  adpIcon,
  alexisIcon,
  BambooHRIcon,
  bretheIcon,
  ceridianIcon,
  charlieIcon,
];

function AddStaffDialog({
  open,
  onClose,
  showIdentityProvider,
  dashboardData,
  staffList,
  refetch,
}) {
  const [generateTrutoLinkToken, { loading }] = useMutation(
    GENERATE_TRUTO_LINK_TOKEN
  );
  const { loading: loadingIntegration, data: integrations } = useQuery(
    GET_AVAILABLE_INTEGRATIONS,
    {
      variables: {
        category: "hris",
      },
    }
  );

  const [isOpen, setIsOpen] = useState(false);
  const [openCsvDialog, setOpenCsvDialog] = useState(false);
  const [openIndivisualStaffDialog, setopenIndivisualStaffDialog] =
    useState(false);
  const [availableIntegratins, setAvailableIntegrations] = useState([]);

  useEffect(() => {
    if (integrations && integrations?.getAvailableIntegrations) {
      setAvailableIntegrations(
        integrations?.getAvailableIntegrations?.list.map((val) => val.label)
      );
    }
  }, [integrations]);

  const handleConnect = async () => {
    const companyName =
      dashboardData?.getAccountDetails?.userCompanyDetails
        ?.customer_company_name || "";

    const sanitizedCompanyName = companyName.replace(/\s+/g, "").toLowerCase();

    const timestamp = Date.now();

    const environment = process.env.REACT_APP_ENVIRONMENT;

    // const tenantId = `${sanitizedCompanyName}-${timestamp}-${environment}`;

    try {
      const { data } = await generateTrutoLinkToken({
        variables: {
          // tenant_id: tenantId,
          // redirect_uri: redirectUri,
        },
      });

      if (!loading) {
        const linkToken = data.generateTrutoLinkToken.linkToken;

        if (!linkToken) {
          alert("Failed to generate link token. Please try again.");
          return;
        }

        // Invoke Truto Link SDK
        const response = await authenticate(linkToken, {
          noBack: true, // Disable the "Back" button
          skipRapidForm: false, // Show the RapidForm UI if defined
          iframe: true, // Open the UI inside an iframe
          // integrations: availableIntegratins,
        });
      }
    } catch (error) {
      console.error("Error during Truto Link connection:", error);
      alert("Failed to connect. Please try again.");
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle fontWeight="bold">
          Add Staff Members
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {showIdentityProvider ? (
            <Box
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: 2,
                padding: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  Add staff from HRMS or identity providers
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Choose from available HRMS or identity providers to fetch your
                  staff list.
                </Typography>
                <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                  {providerIcons.map((icon, index) => (
                    <img
                      key={index}
                      src={icon}
                      alt={`Provider ${index + 1}`}
                      style={{ width: 32, height: 32, borderRadius: "50%" }}
                    />
                  ))}
                </Box>
              </Box>

              <BootstrapTooltip
                title={
                  <>
                    <Typography variant="p">Connect</Typography>
                  </>
                }
                arrow
                placement="right"
              >
                <Box>
                  {loadingIntegration || loading ? (
                    <CircularProgress />
                  ) : (
                    <ArrowIconBtn onClick={handleConnect} />
                  )}
                </Box>
              </BootstrapTooltip>
            </Box>
          ) : (
            <Box
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Not using any identity providers or HRMS systems?
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Add staff manually
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#031B89",
                  fontWeight: "bold",
                  border: "1px solid #C5C9CF",
                  borderRadius: "8px",
                  background: "#F7F7FC",
                }}
                p={1}
              >
                Add Individual Staff Member
                <ArrowIconBtn
                  onClick={() => setopenIndivisualStaffDialog(true)}
                  fontSize="small"
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#031B89",
                  fontWeight: "bold",
                  border: "1px solid #C5C9CF",
                  borderRadius: "8px",
                  background: "#F7F7FC",
                }}
                p={1}
                mt={2}
              >
                Add Staff in Bulk via CSV
                <ArrowIconBtn
                  onClick={() => setOpenCsvDialog(true)}
                  fontSize="small"
                />
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <AddStaffFromProviderDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        close={onClose}
      />
      <CsvBulkUploadDialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        refetch={refetch}
        close={onClose}
      />
      <AddIndividualStaffDialog
        open={openIndivisualStaffDialog}
        onClose={() => setopenIndivisualStaffDialog(false)}
        staffList={staffList}
        refetch={refetch}
        close={onClose}
      />
    </>
  );
}

export default AddStaffDialog;
